
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataStateChangeEvent, GridDataResult } from '@progress/kendo-angular-grid';
import { NotificationService } from '@progress/kendo-angular-notification';
import { orderBy, process, SortDescriptor, State } from '@progress/kendo-data-query';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { AgendasService  } from 'src/app/Services/Agendas/agendas.service';
import { AuthService } from 'src/app/Services/AuthService/auth-service.service';
import { LoaderService } from 'src/app/Services/Loader/loader-service.service';
import { Notification_Service } from 'src/app/Services/Notifications/notification.service';
import { Agendas, UploadedEvidence } from "../../model/agendas"


declare var $: any;



@Component({
  selector: 'app-registered-agent',
  templateUrl: './registered-agent.component.html',
  styleUrls: ['./registered-agent.component.scss']
})
export class RegisteredAgentComponent implements OnInit, OnDestroy {

  userName:string="No Active UserName "
  roomsList=['All','A','B','C', 'D', 'E', 'F', 'G','H','I','J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q']
  selectedRoom = 'All';
  selectedTab =2; 


  
  searchValue="";
  heardFiltered='Unheard Petitions';
  sorting='HearingDate';
  dateValue=null;
  verified=false; 
  Agendas:any[] = [];
  checked=false;
  selectedAgendas:any[] = [];
  uploadedEvidence: UploadedEvidence[]
  gridData:  GridDataResult ;
  transactionsHistory:{UploadedDate:Date}[];
  submissionHistoryLoading = false;
  agentId=0;
  filter: {
          logic: 'and',
          filters: [{ field: 'Agenda', operator: 'contains', value: '20' }]
        }
  prefix: string='';
  public butttonToggleValue =true;
  agSUB : Subscription;
  ausSUB : Subscription;
  saSUB : Subscription;
  euSUB : Subscription;
  private _devTabListener: EventListener;

  public state: State = {
    skip: 0,
    filter: {
      logic: "and",
      filters: [{ field: "agenda", operator: "contains", value: "" }],
    },
  };

  public sort: SortDescriptor[] = [
    {
      field: "ProductName",
      dir: "asc",
    },
  ];
  
  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    const currentFilters: any[] = (this.state?.filter?.filters as any[]) || [];
    const firstFilter: any = currentFilters[0];
    if(currentFilters.length === 1 && firstFilter && firstFilter.field == undefined){//fixing Kendo UI Error
      this.state.filter.filters[0] ={ field: "agenda", operator: "contains", value: "" };
    }
    this.gridData = process(this.transactionsHistory, this.state);
  }

  public getUploadedDateFilterValue(): string {
    const filters: any[] = (this.state?.filter?.filters as any[]) || [];
    const dateFilter: any = filters.find((f: any) => f && f.field === "uploadedDate");
    if (!dateFilter || !dateFilter.value) {
      return "";
    }
    const date = new Date(dateFilter.value);
    if (isNaN(date.getTime())) {
      return "";
    }
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${date.getFullYear()}-${month}-${day}`;
  }

  public onUploadedDateFilterChange(event: any): void {
    const value = event?.target?.value;
    const filters: any[] = ((this.state?.filter?.filters as any[]) || []).filter((f: any) => !(f && f.field === "uploadedDate"));

    if (value) {
      const startDate = new Date(`${value}T00:00:00`);
      const endDate = new Date(`${value}T23:59:59`);
      filters.push({ field: "uploadedDate", operator: "gte", value: startDate });
      filters.push({ field: "uploadedDate", operator: "lte", value: endDate });
    }

    this.state = {
      ...this.state,
      filter: {
        logic: "and",
        filters,
      },
    };

    this.gridData = process(this.transactionsHistory, this.state);
  }

  public sortChange(sort: SortDescriptor[]): void {
    this.sort = sort;
    this.loadProducts();
  }

  private loadProducts(): void {
    this.state.filter={
      logic: "and",
      filters: [{ field: "agenda", operator: "contains", value: "" }],
    };
    this.gridData = {
      data: orderBy(this.transactionsHistory, this.sort),
      total: this.transactionsHistory.length,
    };
  }

  constructor( private notificationService: Notification_Service, private router: Router,private _loaderService:LoaderService , private _agendasService:AgendasService,  public _authService:AuthService) {}

  ngOnDestroy(): void {
    this.agSUB.unsubscribe();
    this.ausSUB.unsubscribe();
    this.saSUB.unsubscribe();
    this.euSUB.unsubscribe();
    if (this._devTabListener) {
      window.removeEventListener('rp-dev-tab-select', this._devTabListener);
    }
  }

  
  ngOnInit(): void {
    // Dev preview: if nav-menu stored a target tab before navigating here, apply it now.
    const devTab = sessionStorage.getItem('rp-dev-target-tab');
    if (devTab) {
      sessionStorage.removeItem('rp-dev-target-tab');
      this.selectNext(Number(devTab));
    }
    // Dev preview: runtime listener for when already on this page.
    this._devTabListener = ((e: Event) => {
      this.selectNext((e as CustomEvent<number>).detail);
    }) as EventListener;
    window.addEventListener('rp-dev-tab-select', this._devTabListener);

    this.agSUB =this._agendasService.agendas.subscribe(x =>{
      this.Agendas = x
      if(x.length ===1 && this.selectedTab===2){
        if(this.selectedAgendas.length ==0 )
          this.selectAgenda(x[0])
        if(!this.notificationService.succNotificationActive){
          this.notificationService.succNotificationActive = true;
            this.notificationService.successNotif("Agenda: (" + x[0].agenda + ") got Automatically Selected.", true);
        }
      }
      else{
        this.selectAgenda(null)
      }
    })
    if(!this.router.url.includes("registered-agent")){
      this.router.navigateByUrl("registered-agent")
    }

    this. ausSUB =this._authService.selectedUser.subscribe(x=>{
      if(x && x._agentId){
        if(this.agentId !== x._agentId){
          this._agendasService.getAllAgendas(x._agentId)
        } 
        this.agentId=x._agentId
      }
    });

    this.saSUB = this._agendasService._selectedAgendas.subscribe(agendas =>{
      this.selectedAgendas= agendas
      if(agendas.length >1){
        if(!this.notificationService.warnNotificationActive){
          this.notificationService.warnNotificationActive = true;
          this.notificationService.warningNotif("When selecting multiple petitions, all evidence selected will be applied to the selected petitions.");
        }
      }
      else{
        if(this.notificationService.notifInstance){
          this.notificationService.notifInstance.hide();
        }
      }
    })

    this.euSUB = this._loaderService.evidenceUpload.subscribe( (UploadedEvidence:any) =>{
      UploadedEvidence.forEach(element =>{
        element.uploadedDate = (new Date(element.uploadedDate))
      })
      this.transactionsHistory =UploadedEvidence;
     this.gridData= process(this.transactionsHistory, this.state);
      this.submissionHistoryLoading = false;
    })

    if(this._authService.getUserName()){
        this.userName =this._authService.getUserName() +'  ('+ this._authService.getAgentId()+')'
    }

    $(document).ready(function () {
      $(".ng-tns-c125-0 .ng-trigger ").each(function (i) { $(this).attr('tabindex', -1); });
      $("input.k-input").each(function (i) { $(this).attr('tabindex', 0); });
      setTimeout(x => {
        $("input.k-input")[0]?.focus();
      }, 1000);
    })
  }

  public getListOfSelectedAgendas(){
    let list = this.selectedAgendas.map((x:Agendas) => x.agenda).join(', ')
    return list;
  }

  public selectNext(value) {
    this.selectedTab =value;
    if(this.notificationService.notifInstance){
      this.notificationService.notifInstance.hide();
    }
    if(value===2){
      this.prefix='';
      this.searchValue='';
      this.clearButtonToggle(false);

      //Clear All Filters
      this.heardFiltered='Unheard Petitions';
      this.searchValue =""
      this.sorting='HearingDate';
      this.dateValue=null;
      this.selectedRoom= 'All';

      //Re Request get All Agendas.
      this._agendasService.filterAgendas(this.heardFiltered, this.searchValue, this.sorting, this.dateValue, this.selectedRoom )
      setTimeout(x => {
        $("input.k-input")[0].focus();
      }, 1000);
      this._loaderService.ClearAllUploadsData();
    }
    if (value === 3) {
      if(!this._authService.getServiceEnvironment() || !this._authService.getTaxYear()) this._authService.isAppOffline()
      setTimeout(x => {
        $("div.k-button.k-upload-button")[0].focus();
      }, 1000);
      this._loaderService.ClearAllUploadsData();
    }
    if(value===4){
      this.submissionHistoryLoading = true;
      this._loaderService.GetAllUploadsData(this.agentId.toString()).pipe(
        finalize(() => {
          this.submissionHistoryLoading = false;
        })
      ).subscribe({
        error: () => {
          if(!this.notificationService.errNotificationActive){
            this.notificationService.errNotificationActive = true;
            this.notificationService.errorNotif('Unable to load submission history. Please try again.');
          }
        }
      });
      setTimeout(x => {
        $("button.btn-success")[0].focus();
      }, 1000);
    }
  }


  selectAgenda(agenda:Agendas | null){
    agenda = this._agendasService.setSelectedAgendas(agenda)
    if(agenda && this._agendasService.dataStore.selectedAgendas.includes(agenda)){
      this.prefix = agenda?.petitionType + '_' + agenda?.agenda
    }
    this.butttonToggleValue =this._agendasService.dataStore.selectedAgendas?.length === 0  //!== this._agendasService.filtered?.length
  }

  clearButtonToggle(value: boolean){
    if(value){
      this._agendasService.selectAllAgendas();
      let ag = this._agendasService.dataStore.selectedAgendas[0]
      this.prefix = ag?.petitionType + '_' + ag?.agenda
    }
    else{
      this._agendasService.unselectAgendas()
    }
    this.butttonToggleValue = !value;
  }

  public onSelectedChange(e: any): void {
    if(e && e.currentTarget){
      if(e.currentTarget.name === 'heard')this.heardFiltered=e.currentTarget.defaultValue;
      if(e.currentTarget.name === 'sort')this.sorting=e.currentTarget.defaultValue;
    }
    this.selectAgenda(null)
    this._agendasService.filterAgendas(this.heardFiltered, this.searchValue, this.sorting, this.dateValue, this.selectedRoom )
  }

  public onHeardFilterTab(event: KeyboardEvent, currentId: string): void {
    const filterIds = ['unheardPetitions', 'heardPetitions', 'unscheduledPetitions', 'allPetitions'];
    const currentIndex = filterIds.indexOf(currentId);
    if (currentIndex < 0) {
      return;
    }

    if (event.shiftKey) {
      if (currentIndex > 0) {
        event.preventDefault();
        (document.getElementById(filterIds[currentIndex - 1]) as HTMLInputElement)?.focus();
      }
      return;
    }

    if (currentIndex < filterIds.length - 1) {
      event.preventDefault();
      (document.getElementById(filterIds[currentIndex + 1]) as HTMLInputElement)?.focus();
    }
  }

  public onChange(): void {
    this._agendasService.filterAgendas( this.heardFiltered, this.searchValue, this.sorting, this.dateValue, this.selectedRoom)
  }

}
